import DOMPurify from "dompurify";

/**
 * Sanitizes an HTML string to prevent XSS attacks.
 * 
 * @param {string} html - The raw HTML string to be sanitized.
 * @returns {{__html: string}} An object containing the sanitized HTML, formatted for use with dangerouslySetInnerHTML.
 */
export const sanitizeHtml = (html) => {
  return { __html: DOMPurify.sanitize(html) };
};